// routes

import SvgIconStyle from '../../components/SvgIconStyle'

// components

// ----------------------------------------------------------------------
function path(root: string, sublink: string) {
  return `${root}${sublink}`
}

const ROOTS_DASHBOARD = ''

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  // staff: {
  //   root: path(ROOTS_DASHBOARD, 'staff-info'),
  //   pageBasicInfo: path(ROOTS_DASHBOARD, 'staff-info/basic'),
  //   pageSalaryInfo: path(ROOTS_DASHBOARD, 'staff-info/salary'),
  //   pagePayRoll: path(ROOTS_DASHBOARD, 'payroll')
  // },
  time_sheet: {
    root: path(ROOTS_DASHBOARD, 'time-sheet'),
    pageTimeSheet: path(ROOTS_DASHBOARD, 'time-sheet/check'),
    pageSubmitForm: path(ROOTS_DASHBOARD, 'time-sheet/submit'),
    blogs: path(ROOTS_DASHBOARD, 'time-sheet/blogs')
  },
  app: {
    root: path(ROOTS_DASHBOARD, '/app')
  }
}

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
)

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  calendar: getIcon('ic_calendar'),
  embedded: getIcon('ic_embedded')
}

const sidebarConfig = [
  // {
  //   subheader: 'staff-info',
  //   items: [
  //     {
  //       title: 'Thông tin cá nhân',
  //       path: PATH_DASHBOARD.staff.root,
  //       icon: ICONS.user,
  //       children: [
  //         {
  //           title: 'Thông tin cơ bản',
  //           path: PATH_DASHBOARD.staff.pageBasicInfo,
  //           icon: ICONS.dashboard
  //         },
  //         {
  //           title: 'Thông tin lương',
  //           path: PATH_DASHBOARD.staff.pageSalaryInfo,
  //           icon: ICONS.dashboard
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    subheader: 'time-sheet',
    items: [
      {
        title: 'Bảng Chấm Công',
        path: PATH_DASHBOARD.time_sheet.pageTimeSheet,
        icon: ICONS.calendar

        // children: [
        //   // {
        //   //   title: 'Kiểm tra time sheet',
        //   //   path: PATH_DASHBOARD.time_sheet.pageTimeSheet,
        //   //   icon: ICONS.dashboard
        //   // }
        //   // {
        //   //   title: 'Submit form',
        //   //   path: PATH_DASHBOARD.time_sheet.pageSubmitForm,
        //   //   icon: ICONS.dashboard
        //   // }
        // ]
      },
      {
        title: 'Submit form',
        path: PATH_DASHBOARD.time_sheet.pageSubmitForm,
        icon: ICONS.dashboard
      },
      {
        title: 'Blogs',
        path: PATH_DASHBOARD.time_sheet.blogs,
        icon: ICONS.analytics
      }
    ]
  }
  // {
  //   subheader: 'salary',
  //   items: [
  //     {
  //       title: 'Phiếu lương cá nhân',
  //       path: PATH_DASHBOARD.staff.pagePayRoll,
  //       icon: ICONS.dashboard
  //     }
  //   ]
  // }
]

export default sidebarConfig
